"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reselect = require("reselect");

var _core = require("@react-page/core");

var _focus = require("@react-page/core/lib/selector/focus");

var _ContentBlockSave = _interopRequireDefault(require("../ContentBlockSave"));

var S = _interopRequireWildcard(require("./styled"));

var _excluded = ["id", "searchNodeEverywhere", "updateCellContent", "updateCellLayout", "editor", "getLibraryBlocks"],
    _excluded2 = ["focus", "editor"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Inner = function Inner(_ref) {
  var id = _ref.id,
      searchNodeEverywhere = _ref.searchNodeEverywhere,
      updateCellContent = _ref.updateCellContent,
      updateCellLayout = _ref.updateCellLayout,
      editor = _ref.editor,
      getLibraryBlocks = _ref.getLibraryBlocks,
      props = _objectWithoutProperties(_ref, _excluded);

  var result = searchNodeEverywhere(id);

  if (!result) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "p-3 text-center"
    }, "You are in Edit mode.", /*#__PURE__*/_react["default"].createElement("br", null), "Click the page element that you would like to edit.");
  }

  var _result$node = result.node,
      _result$node$rows = _result$node.rows,
      rows = _result$node$rows === void 0 ? [] : _result$node$rows,
      _result$node$layout = _result$node.layout;
  _result$node$layout = _result$node$layout === void 0 ? {} : _result$node$layout;
  var _result$node$layout$p = _result$node$layout.plugin;
  _result$node$layout$p = _result$node$layout$p === void 0 ? {} : _result$node$layout$p;
  var _result$node$layout$p2 = _result$node$layout$p.Component,
      LayoutComponent = _result$node$layout$p2 === void 0 ? undefined : _result$node$layout$p2,
      _result$node$layout$p3 = _result$node$layout$p.config,
      layoutConfig = _result$node$layout$p3 === void 0 ? undefined : _result$node$layout$p3,
      _result$node$layout$p4 = _result$node$layout$p.name,
      layoutType = _result$node$layout$p4 === void 0 ? undefined : _result$node$layout$p4,
      _result$node$layout$p5 = _result$node$layout$p.text,
      layoutTitle = _result$node$layout$p5 === void 0 ? undefined : _result$node$layout$p5,
      _result$node$layout$s = _result$node$layout.state,
      layoutState = _result$node$layout$s === void 0 ? {} : _result$node$layout$s,
      _result$node$content = _result$node.content;
  _result$node$content = _result$node$content === void 0 ? {} : _result$node$content;
  var _result$node$content$ = _result$node$content.plugin;
  _result$node$content$ = _result$node$content$ === void 0 ? {} : _result$node$content$;
  var _result$node$content$2 = _result$node$content$.Component,
      ContentComponent = _result$node$content$2 === void 0 ? undefined : _result$node$content$2,
      _result$node$content$3 = _result$node$content$.config,
      contentConfig = _result$node$content$3 === void 0 ? undefined : _result$node$content$3,
      _result$node$content$4 = _result$node$content$.name,
      contentType = _result$node$content$4 === void 0 ? undefined : _result$node$content$4,
      _result$node$content$5 = _result$node$content$.text,
      contentTitle = _result$node$content$5 === void 0 ? undefined : _result$node$content$5,
      _result$node$content$6 = _result$node$content.state,
      contentState = _result$node$content$6 === void 0 ? {} : _result$node$content$6;

  if (rows.length && LayoutComponent) {
    var _layoutConfig$FormCom = layoutConfig.FormComponent,
        FormComponent = _layoutConfig$FormCom === void 0 ? null : _layoutConfig$FormCom,
        _layoutConfig$Decorat = layoutConfig.DecoratedForm,
        DecoratedForm = _layoutConfig$Decorat === void 0 ? null : _layoutConfig$Decorat;
    var _props = {
      id: id,
      config: layoutConfig,
      state: layoutState,
      onChange: updateCellLayout
    };
    return /*#__PURE__*/_react["default"].createElement(S.FormWrapper, null, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-uppercase mb-2"
    }, layoutTitle), FormComponent ? /*#__PURE__*/_react["default"].createElement(FormComponent, _props) : '', DecoratedForm && /*#__PURE__*/_react["default"].createElement(DecoratedForm, _props), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_ContentBlockSave["default"], _extends({}, result, {
      getLibraryBlocks: getLibraryBlocks,
      editor: editor
    })));
  } else if (ContentComponent) {
    var _contentConfig$FormCo = contentConfig.FormComponent,
        _FormComponent = _contentConfig$FormCo === void 0 ? null : _contentConfig$FormCo,
        _contentConfig$Decora = contentConfig.DecoratedForm,
        _DecoratedForm = _contentConfig$Decora === void 0 ? null : _contentConfig$Decora;

    var _props2 = {
      id: id,
      config: contentConfig,
      state: contentState,
      onChange: updateCellContent
    };
    return /*#__PURE__*/_react["default"].createElement(S.FormWrapper, null, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-uppercase mb-2"
    }, contentTitle), _FormComponent ? /*#__PURE__*/_react["default"].createElement(_FormComponent, _props2) : null, _DecoratedForm && /*#__PURE__*/_react["default"].createElement(_DecoratedForm, _props2));
  }

  return /*#__PURE__*/_react["default"].createElement(S.FormWrapper, null, "Whoops");
};

var mapStateToProps = (0, _reselect.createStructuredSelector)({
  searchNodeEverywhere: function searchNodeEverywhere(state) {
    return function (id) {
      return _core.Selectors.Editable.searchNodeEverywhere(state, id);
    };
  }
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var id = _ref2.id;
  return (0, _redux.bindActionCreators)({
    updateCellContent: _core.Actions.Cell.updateCellContent(id),
    updateCellLayout: _core.Actions.Cell.updateCellLayout(id)
  }, dispatch);
};

var ConnectedInner = (0, _core.connect)(mapStateToProps, mapDispatchToProps)(Inner);

var EditForm = function EditForm(_ref3) {
  var focus = _ref3.focus,
      editor = _ref3.editor,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      id = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    if (focus && focus !== id) {
      setId(focus);
    }
  }, [focus]);
  return /*#__PURE__*/_react["default"].createElement(ConnectedInner, _extends({
    id: id,
    editor: editor
  }, props));
};

var _default = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  focus: _focus.focus
}), {})(EditForm);

exports["default"] = _default;